import type { InventoryResource } from '@repo/api-gw-sdk';

import {
  apps,
  sourceAccountId,
  backupPolicies,
  backupRegions,
  backupStorageSize,
  dataClasses,
  environment,
  resourceId,
  resourceName,
  backupStatus,
  resourceType,
  sourceRegion,
  sourceStorageSize,
  subnets,
  clusterName,
  globalClusterIdentifier,
  tags,
  vpc,
  vaults,
  id,
  genericSnapshotsDistinctDateCount,
  dateDiscovered,
  createdTime,
  resourceGroupName,
  cloudProvider,
  securityScanConclusion,
  securityAssignmentStatus,
  sourceAccountName,
  eonSnapshotsCount,
  sensitivityAnnotations,
} from '@/components/queryBuilder/properties';
import { ResourceNameCell } from '@/components/queryBuilder/resourceName/resourceNameCell';
import type { FilterProperty } from '@/types/advanceFilter';

const baseInventoryListTableColumns = [
  cloudProvider,
  resourceType,
  resourceId,
  tags,
  securityScanConclusion,
  dataClasses,
  environment,
  apps,
  sensitivityAnnotations,
  backupPolicies,
  vaults,
  backupRegions,
  sourceStorageSize,
  backupStorageSize,
  eonSnapshotsCount,
  genericSnapshotsDistinctDateCount,
  dateDiscovered,
  sourceAccountName,
  sourceAccountId,
  sourceRegion,
  vpc,
  subnets,
  clusterName,
  globalClusterIdentifier,
  resourceGroupName,
  createdTime,
  securityAssignmentStatus,
] as FilterProperty<InventoryResource>[];

export const fullInventoryListTableColumns = [
  id,
  backupStatus,
  {
    ...resourceName,
    column: {
      ...resourceName.column,
      cell: ({ row, table }) => {
        return <ResourceNameCell row={row} table={table} />;
      },
    },
  },
  ...baseInventoryListTableColumns,
] as FilterProperty<InventoryResource>[];

export const inventoryListTableColumns = [
  id,
  backupStatus,
  resourceName,
  ...baseInventoryListTableColumns,
] as FilterProperty<InventoryResource>[];

export const inventoryListTableHiddenColumns = [
  id,
  tags,
  resourceGroupName,
  sourceAccountId,
  sourceAccountName,
  resourceId,
  vpc,
  subnets,
  sourceRegion,
  backupRegions,
  vaults,
  backupStorageSize,
  dateDiscovered,
  createdTime,
  cloudProvider,
  securityScanConclusion,
  securityAssignmentStatus,
  clusterName,
  globalClusterIdentifier,
  sensitivityAnnotations,
] as FilterProperty<InventoryResource>[];
